<app-page-content>
<app-doenkids-menu-bar menuBar class="transparent" [loading]="listLoading$ | async">
  <div left class="nav-controls">
    @if (!(showMobileToolbar$ | async)) {
      <button mat-raised-button (click)="today()">
        {{ 'calendar.today' | translate }}
      </button>
      <button
        (click)="previous()"
        mat-icon-button
        matTooltipPosition="below"
        [matTooltipShowDelay]="100"
        [matTooltip]="'calendar.previous_month' | translate"
        >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button
        (click)="next()"
        mat-icon-button
        matTooltipPosition="below"
        [matTooltipShowDelay]="100"
        [matTooltip]="'calendar.next_month' | translate"
        >
        <mat-icon>chevron_right</mat-icon>
      </button>
      <span class="title">
        {{ currentViewTitle }}
      </span>
    }
  </div>
  <div right>
    <form class="form-wrapper">
      <button
        (click)="toggleDownloadSelection()"
        class="download"
        [class.selecting]="selecting"
        mat-icon-button
        [matTooltip]="'calendar.programs.select.tooltip' | translate"
        ><mat-icon>get_app</mat-icon></button>
      @if (selecting) {
        <button
          mat-button
          (click)="downloadPrograms()"
          [disabled]="selectedPrograms.length === 0"
          color="primary"
          >
          {{ 'calendar.programs.download' | translate: {programCount: selectedPrograms.length} }}
        </button>
      }
      @if (selecting) {
        <button
          mat-button
          (click)="makeBooklet()"
          [disabled]="selectedPrograms.length === 0"
          color="primary"
          >
          {{ 'calendar.programs.booklet.create' | translate: {programCount: selectedPrograms.length} }}
        </button>
      }
      <app-responsive-toolbar-content
        class="toolbar-container"
        icon="more_vert"
        [isOpen]="toolBarContentOpen | async"
        tooltip="calendar.responsive_toolbar.tooltip"
        (toolBarMenuOpen)="updateToolbarMenuOpen($event)"
        >
        <ng-template #content>
          <mat-slide-toggle [formControl]="showWeekend" color="primary">{{ 'calendar.weekend' | translate }}</mat-slide-toggle>
          @if (calendarTypeToDisplay) {
            <mat-form-field appearance="outline">
              <mat-select [(value)]="calendarTypeToDisplay">
                @for (calendarType of calendarTypes$ | async; track calendarType) {
                  <mat-option
                    (click)="changeView(calendarType.view)"
                    [value]="calendarType.value"
                    >
                    {{ calendarType.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <mat-form-field class="program-status" appearance="outline">
            <mat-select [value]="(currentProgramStatus$ | async)" (selectionChange)="changePublicationStatus($event)" [multiple]="true" [disabled]="(isReader$ | async)">
              @for (status of (programStatuses$ | async); track status) {
                <mat-option [value]="status.id">
                  {{ status.translatedName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </ng-template>
      </app-responsive-toolbar-content>
    </form>
  </div>
</app-doenkids-menu-bar>
<div content>

@if (showMobileToolbar$ | async) {
  <div class="mobile-nav-controls">
    <button
      (click)="previous()"
      mat-icon-button
      [matTooltip]="'calendar.previous_month' | translate"
      >
      <mat-icon>chevron_left</mat-icon>
    </button>
    <span class="title">
      {{ currentViewTitle }}
    </span>
    <button
      (click)="next()"
      mat-icon-button
      [matTooltip]="'calendar.next_month' | translate"
      >
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
}

<div class="page-container animated fadeIn" *ngVar="(error$ | async) as error">
    <ng-container *ngVar="(unpublishedProgramCount$ | async) as unpublishedProgramCount">
      @if (unpublishedProgramCount?.count > 0) {
        <div class="unpublished_programs">
          {{ 'calendar.unpublished_programs' | translate: { unpublishedCount: unpublishedProgramCount.count, endDate: getFormattedDate(unpublishedProgramCount.end) } }}
        </div>
      }
    </ng-container>
    @if (!error) {
      <div class="search-bar">
        <mat-form-field appearance="outline" >
          <mat-label>{{ 'calendar.programs.search.label' | translate }}</mat-label>
          @if (possibleContentLanguages?.length > 1) {
            <mat-select
              (click)="handleFlagInputClick($event)"
              matPrefix
              class="content-language-select"
              hideSingleSelectionIndicator
              [formControl]="contentLanguageControl"
              panelWidth="56px"
              >
              @if (contentLanguageControl.value) {
                <mat-select-trigger>
                  <mat-icon [svgIcon]="contentLanguageControl.value.toLowerCase()"></mat-icon>
                </mat-select-trigger>
              }
              @for (contentLanguage of possibleContentLanguages; track contentLanguage) {
                <mat-option [value]="contentLanguage">
                  <mat-icon [svgIcon]="contentLanguage.toLowerCase()"></mat-icon>
                </mat-option>
              }
            </mat-select>
          }
          <input
            type="text"
            [placeholder]="'calendar.programs.search.placeholder' | translate"
            [attr.aria-label]="'calendar.programs.search.label' | translate"
            matInput
            [formControl]="programSearchInput"
            [matAutocomplete]="auto"
            >
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selectProgram($event)" [displayWith]="getProgramName">
            @for (program of programSearchResults$ | async; track program) {
              <mat-option [value]="program">
                <div class="flex-col flex-1">
                  <span style="max-width: 400px; overflow: hidden; text-overflow: ellipsis;">
                    {{program.name}}
                  </span>
                  <span>
                    {{ program.from | i18n_date: 'dd MMM YYYY' | async }} - {{ program.to | i18n_date: 'dd MMM YYYY' | async }}
                  </span>
                </div>
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    }

    @if (error) {
      <span class="error">
        {{ 'calendar.programs.create.only_locations' | translate }}
      </span>
    }
    <div [class.editing-disabled]="error">
      <full-calendar #doenkidsCalendar class="calendar" [options]="calendarOptions$ | async"></full-calendar>
    </div>
    <div class="legenda">
      <ul>
        @for (status of programStatuses$ | async; track status) {
          @if ((currentProgramStatus$ | async).includes(status.id)) {
            <li>
              <span class="legenda-item status-{{status.id}}"></span>
              {{ status.translatedName }}
            </li>
          }
        }

      </ul>
      {{ 'calendar.disclaimer' | translate }}
    </div>
  </div>

</div>
</app-page-content>
